import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

import { BreakpointMatches, useBreakpoint } from "./breakpoints.provider";

export const ConditionalBreakPoint = ({
    children,
    condition
}: RequireChildrenFor<{
    condition: (breakpoints: BreakpointMatches) => boolean;
}>) => {
    const { breakpoints } = useBreakpoint();
    if (condition(breakpoints)) {
        return <>{children}</>;
    }
    return null;
};
